import { render } from "./Formulation.vue?vue&type=template&id=42f1a6a4"
import script from "./Formulation.vue?vue&type=script&lang=js"
export * from "./Formulation.vue?vue&type=script&lang=js"

import "./Formulation.vue?vue&type=style&index=0&id=42f1a6a4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__